module.exports = __webpack_public_path__ + "img/LOOM.2c10500f.svg";